export default {
	game_id: "joker_boom",
	gameName: "Joker Boom",

	stageWidth: 1280,
	stageHeight: 720,

	scripts: [
		"framework/src/vendor/jquery.min.js",
		"framework/src/vendor/tween.js",
		"framework/src/vendor/ph.js",
	],

	infoPages: {
		separated: true,
	},

	game: {
		audio: {
			tracks: [],
		},
		webfonts: ["UbuntuMono-Regular", "Audiowide-Regular"],
	},
	system: {
		audio: {
			tracks: [
				{
    name: 'Jackpot_sound',
    classVol: 'volume.normalWin',
    loop: false,
},
{
    name: 'JokerBonus_alert',
    classVol: 'volume.normalWin',
    loop: false,
},

			],
		},
	},
};
